import { ImagePicture } from 'approot/shared/images/images';

import emojiLightbulbAvif from './image-emoji-lightbulb.avif';
import emojiLightbulbWebp from './image-emoji-lightbulb.webp';
import emojiLightbulbPng from './image-emoji-lightbulb.png';

const ImageEmojiLightbulb = ({ width }: { width?: number }) => (
  <ImagePicture
    lazyLoad
    style={width ? { width, height: width } : undefined}
    avif={{ path: emojiLightbulbAvif }}
    webp={{ path: emojiLightbulbWebp }}
    png={{ path: emojiLightbulbPng }}
  />
);

export default ImageEmojiLightbulb;
